import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Note from "@/services/note";
import { RegisterNote } from "@/dtos/Note.dto";

/**
 * Composable for registering a new note
 */
export function useRegisterNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (note: RegisterNote) => {
      const result = await Note.registerNote(note);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to register note");
      }
      return result.data.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["notes", variables.contactId] });
    },
  });
}
